<div fxLayout="column" fxLayoutAlign="start" class="margin-15">
<app-i18n-list-table [langs$]="langs$">
</app-i18n-list-table>
</div>
